import { useDispatch, useSelector } from "react-redux";

import { CONTACTS_SEARCH_RESULTS_LOWER_LIMIT } from "app/pages/sales-intelligence/modules/company-analysis/constants/contacts";
import { useSelectedAvailableCountries } from "app/pages/sales-intelligence/modules/company-analysis/hooks/useSelectedAvailableCountries";
import companyAnalysisTrackingService from "app/pages/sales-intelligence/modules/company-analysis/services/tracking/companyAnalysisTrackingService";
import {
    contactsTableFiltersChangedAction,
    employeeLocationIdsSelectedAction,
} from "app/pages/sales-intelligence/modules/company-analysis/store/contacts/action-creators";
import { CONTACTS_SEARCH_TABLE_INITIAL_PAGE } from "app/pages/sales-intelligence/sub-modules/contacts-search/constants/table";
import {
    selectContactsResultsAreBeingFetched,
    selectNumberOfContactsSearchResults,
} from "app/pages/sales-intelligence/sub-modules/contacts-search/store/selectors";
import { selectProfilesAreBeingFetched } from "app/pages/sales-intelligence/sub-modules/contacts-search-profiles/store/selectors";
import { selectLoadingContactStatus } from "app/pages/sales-intelligence/sub-modules/contacts-tab/store/selectors";

import EmployeeLocationDropdown from "./EmployeeLocationDropdown";

const EmployeeLocationDropdownContainer = () => {
    const dispatch = useDispatch();

    const {
        selectedCountriesIds,
        availableCountries,
        isLoading: isLoadingCountByCountries,
    } = useSelectedAvailableCountries();

    const numberOfSearchResults = useSelector(selectNumberOfContactsSearchResults);
    const areProfilesBeingFetched = useSelector(selectProfilesAreBeingFetched);
    const isLoadingContactsResults = useSelector(selectContactsResultsAreBeingFetched);
    const isLoadingContactStatus = useSelector(selectLoadingContactStatus);

    const isLoading =
        isLoadingContactStatus || isLoadingContactsResults || areProfilesBeingFetched || isLoadingCountByCountries;

    function handleCountriesSelect(ids: readonly number[]) {
        if (numberOfSearchResults > CONTACTS_SEARCH_RESULTS_LOWER_LIMIT) {
            companyAnalysisTrackingService.contacts.trackEmployeeLocationSelected();
        }

        dispatch(employeeLocationIdsSelectedAction(ids));
        dispatch(
            contactsTableFiltersChangedAction({
                page: CONTACTS_SEARCH_TABLE_INITIAL_PAGE,
            }),
        );
    }

    function handleOpen() {
        if (numberOfSearchResults > CONTACTS_SEARCH_RESULTS_LOWER_LIMIT) {
            companyAnalysisTrackingService.contacts.trackEmployeeLocationDropdownOpened();
        }
    }

    return (
        <EmployeeLocationDropdown
            countries={availableCountries}
            selectedIds={selectedCountriesIds}
            isDisabled={isLoading || availableCountries?.length === 0}
            onSelect={handleCountriesSelect}
            onOpen={handleOpen}
        />
    );
};

export default EmployeeLocationDropdownContainer;
